import { BaseWalletAdapter, WalletReadyState } from '@solana/wallet-adapter-base';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-phantom';
import { SolflareWalletAdapter } from '@solana/wallet-adapter-solflare';
import {
    backpackBrowseUrl,
    isInPhantom,
    isInSolflare,
    isInWalletBrowser,
    isProbablyMobile,
    phantomBrowseUrl,
    solflareBrowseUrl,
    trustBrowseUrl
} from '../utils/mobileWallet';

const shouldRedirectToWalletBrowser = (isInsideWallet) => (
    isProbablyMobile() && !isInsideWallet()
);

export class MobilePhantomWalletAdapter extends PhantomWalletAdapter {
    get readyState() {
        if (shouldRedirectToWalletBrowser(isInPhantom)) {
            return WalletReadyState.Loadable;
        }
        return super.readyState;
    }

    async autoConnect() {
        // Never bounce to Phantom on page load; wait for an explicit tap.
        if (shouldRedirectToWalletBrowser(isInPhantom)) {
            return;
        }
        return super.autoConnect();
    }

    async connect() {
        if (shouldRedirectToWalletBrowser(isInPhantom)) {
            window.location.href = phantomBrowseUrl();
            return;
        }
        return super.connect();
    }
}

export class MobileSolflareWalletAdapter extends SolflareWalletAdapter {
    async autoConnect() {
        if (shouldRedirectToWalletBrowser(isInSolflare)) {
            return;
        }
        return super.autoConnect();
    }

    async connect() {
        if (shouldRedirectToWalletBrowser(isInSolflare)) {
            window.location.href = solflareBrowseUrl();
            return;
        }
        return super.connect();
    }
}

class InAppBrowserWalletAdapter extends BaseWalletAdapter {
    constructor({ name, url, icon, buildBrowseUrl }) {
        super();
        this.name = name;
        this.url = url;
        this.icon = icon;
        this.buildBrowseUrl = buildBrowseUrl;
        this.supportedTransactionVersions = null;
    }

    get publicKey() {
        return null;
    }

    get connecting() {
        return false;
    }

    get readyState() {
        if (typeof window === 'undefined') {
            return WalletReadyState.Unsupported;
        }
        if (isInWalletBrowser()) {
            return WalletReadyState.NotDetected;
        }
        return isProbablyMobile() ? WalletReadyState.Loadable : WalletReadyState.NotDetected;
    }

    async autoConnect() {
        return;
    }

    async connect() {
        window.location.href = this.buildBrowseUrl();
    }

    async disconnect() {
        return;
    }

    async sendTransaction() {
        throw new Error('Open this site inside your Solana wallet browser to continue');
    }
}

export const createMobileWalletAdapters = (network) => [
    new MobilePhantomWalletAdapter(),
    new MobileSolflareWalletAdapter({ network }),
    new InAppBrowserWalletAdapter({
        name: 'Trust',
        url: 'https://trustwallet.com',
        icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48cmVjdCB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHJ4PSIxMiIgZmlsbD0iIzMzNzVFQyIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0yNCA5bDEyIDd2MTAuMmMwIDcuNi00LjcgMTQuNy0xMiAxNy44LTcuMy0zLjEtMTItMTAuMi0xMi0xNy44VjE2bDEyLTdaIi8+PC9zdmc+',
        buildBrowseUrl: trustBrowseUrl
    }),
    new InAppBrowserWalletAdapter({
        name: 'Backpack',
        url: 'https://backpack.app',
        icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48cmVjdCB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHJ4PSIxMiIgZmlsbD0iI0UxMzU2MCIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNSAxNmgxOHY1SDE1em0wIDhoMTh2MTVIMTV6Ii8+PC9zdmc+',
        buildBrowseUrl: backpackBrowseUrl
    })
];
